module.exports = __webpack_public_path__ + "static/media/heart.0d9ff4df.svg";